import { AUTH_BASE_PATH } from '@/config/baseModulesLink.tsx';

export const AUTH_LINKS = {
  selectMode: `/${AUTH_BASE_PATH}/select-mode`,
  login: `/${AUTH_BASE_PATH}/login`,
  otp: `/${AUTH_BASE_PATH}/login/otp`,
  register: `/${AUTH_BASE_PATH}/register`,
  auth: `/${AUTH_BASE_PATH}`,
};
